import { CardTitle } from "react-migration/components/CardTitle";

export function ComparablesSelectionTitle() {
  return <CardTitle>Comparables</CardTitle>;
}
